import React from 'react'
import { Box, Typography, Paper, Button, Divider, Chip, Alert } from '@mui/material'
import { CheckCircle as CheckIcon, LocalShipping as ShippingIcon, History as HistoryIcon } from '@mui/icons-material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import CustomerLayout from '@/components/Layout/CustomerLayout'
import { mockOrders } from '@/data/mockData'

export const CheckoutCompletePage: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const orderId = Number(searchParams.get('orderId')) || mockOrders[0]?.OrderId

  const targetOrder = mockOrders.find((o) => o.OrderId === orderId) || mockOrders[0]

  return (
    <CustomerLayout>
      <Box sx={{ maxW: 600, mx: 'auto', py: 4 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: 3, textAlign: 'center', bgcolor: '#ffffff' }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: '#dcfce7',
              color: '#16a34a',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2,
            }}
          >
            <CheckIcon sx={{ fontSize: 40 }} />
          </Box>

          <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: '#0f172a' }}>
            ご注文とカード与信枠の確保が完了しました
          </Typography>

          <Typography variant="body2" color="text.secondary" paragraph>
            HighLandirect をご利用いただき誠にありがとうございます。<br />
            ご注文の受託手続きとStripeでのカード与信枠確保（仮売上）が正常に完了いたしました。
          </Typography>

          <Box sx={{ bgcolor: '#f8fafc', p: 3, borderRadius: 2, my: 3, border: '1px solid #e2e8f0', textAlign: 'left' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant="subtitle2" color="text.secondary">
                ご注文番号
              </Typography>
              <Typography variant="subtitle1" fontWeight={700} color="primary">
                #{targetOrder.OrderId}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant="subtitle2" color="text.secondary">
                決済ステータス
              </Typography>
              <Chip label="仮売上（与信枠確保済み）" color="warning" size="small" sx={{ fontWeight: 700 }} />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant="subtitle2" color="text.secondary">
                ご請求合計金額
              </Typography>
              <Typography variant="h6" fontWeight={700} color="#0f172a">
                ¥{targetOrder.OrderTotal.toLocaleString()} (税込・送料込)
              </Typography>
            </Box>

            <Divider sx={{ my: 1.5 }} />

            <Typography variant="caption" color="text.secondary" display="block">
              ご依頼主：{targetOrder.ShipperName || 'お客様'}<br />
              お届け先：{targetOrder.OrderDetails?.[0]?.ConsigneeName || 'ご指定先'}
            </Typography>
          </Box>

          <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="caption" display="block">
              💡 <strong>今後の流れ：</strong><br />
              当店の配送センターにて出荷手続きおよびヤマト運輸への引渡しが行われます。<br />
              <strong>商品出荷・お届け完了時にカードの本決済（引き落とし）が自動実行されます。</strong>
            </Typography>
          </Alert>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/mypage/orders')}
              startIcon={<HistoryIcon />}
              sx={{ textTransform: 'none' }}
            >
              マイ注文履歴を見る
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate('/checkout')}
              startIcon={<ShippingIcon />}
              sx={{ bgcolor: '#2563eb', textTransform: 'none' }}
            >
              続けて購入する
            </Button>
          </Box>
        </Paper>
      </Box>
    </CustomerLayout>
  )
}
export default CheckoutCompletePage
